var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"marquee-text-root"},[(_vm.isPreRender)?_c('div',{key:"hideContent"}):_c('div',{ref:"content",class:[
            'marquee-text-content',
            {
                horizontal: _vm.scrollDirect === _vm.SCROLL_DIRECT.HORIZONTAL,
                vertical: _vm.scrollDirect === _vm.SCROLL_DIRECT.VERTICAL,
                continuous: _vm.scrollType === _vm.SCROLL_TYPE.CONTINUOUS,
                page: _vm.scrollType === _vm.SCROLL_TYPE.PAGE,
                seamless: _vm.isSeamless
            }
        ],style:({
            '--scroll-time': (_vm.scrollTime + "s"),
            '--page-time': (_vm.pageTime + "s"),
            '--content-width': _vm.cssContentWidth + 'px',
            '--content-height': _vm.cssContentHeight + 'px',
            '--transform-x': _vm.cssTranslateX + 'px',
            '--transform-y': _vm.cssTranslateY + 'px'
        })},_vm._l((_vm.contentList),function(item,index){return _c('div',{key:index,ref:"contentItem",refInFor:true,staticClass:"item",style:({
                '--content-margin': _vm.cssContentMargin + 'px'
            })},[_c('div',{staticClass:"content-wrapper",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }